import { render, staticRenderFns } from "./technical-specification-status-label.vue?vue&type=template&id=427a77de&scoped=true"
import script from "./technical-specification-status-label.vue?vue&type=script&lang=js"
export * from "./technical-specification-status-label.vue?vue&type=script&lang=js"
import style0 from "./technical-specification-status-label.vue?vue&type=style&index=0&id=427a77de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427a77de",
  null
  
)

export default component.exports